<template>
    <div class="max-auto px-4">
      <v-card>
        <div class="d-flex align-end my-3">
          <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
            <v-icon color="white"> mdi-bookmark </v-icon>
          </v-card>
          <span class="h4 ml-1 mb-n1">实训任务资源列表</span>
          <v-spacer></v-spacer>
          <v-btn color="success" class="mr-4" @click.stop="showEdit">上传资源文件</v-btn>
        </div>
        <div class="pa-4">
          <v-data-table
            :headers="headers"
            :items="items"
            :sort-by="['currentSort', 'currentSortOrder']"
            :items-per-page="pagination.perPage"
            :page="pagination.currentPage"
            multi-sort
            hide-default-footer
            no-data-text="暂未创建用户组"
            class="paginated-table table-striped table-hover"
          >
            <template v-slot:top>
              <v-row justify="space-between">
                <v-col class="d-flex" cols="6" sm="2">
                  <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                </v-col>
                <v-col class="d-flex" cols="6" sm="2">
                  <v-text-field v-model="queryParams.name" label="查找" type="search" class="mb-3" clearable style="width: 200px"></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.option="{ item }">
              <v-btn icon color="success" small @click.native="checked(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="error" small @click.native="handleDelete(item)">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <div class="d-flex justify-space-between align-center mt-4">
            <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
            <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"> </pagination>
          </div>
        </div>
      </v-card>
    </div>
  </template>
  
  <script>
  import { listUserGroup, delUserGroup } from '@/api/admin/user_group'
  import { Pagination } from '@/components'
  import Swal from "sweetalert2";

  export default {
    components: { Pagination },
    computed: {
      from() {
        return (this.pagination.currentPage - 1) * this.pagination.perPage
      },
      to() {
        return this.pagination.currentPage * this.pagination.perPage
      },
      total() {
        const total = this.pagination.total ?? 0
        return total
      }
    },
    data: () => ({
      selectedItem: 1,
      items: [],
      headers: [
        { text: '资源名称', align: 'center', value: 'name' },
        { text: '实训任务名称', align: 'center', value: 'name' },

        { text: '注册时间', align: 'center', value: 'updated_at' },
        { text: '文件大小', align: 'center', value: 'updated_at' },

        { text: '文件类型', align: 'center', value: 'updated_at' },

        { text: '实训名称', align: 'center', value: 'updated_at' },
        { text: '课程名称', align: 'center', value: 'updated_at' },


        { text: '编辑', align: 'center', value: 'option', width: '100px' }
      ],
      currentSort: 'name',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15, 25],
        total: 0
      },
      queryParams: {}
    }),
    created() {
      this.loadData();
    },
    methods: {
      async loadData() {
        const res = await listUserGroup(Object.assign(this.pagination, this.queryParams))
        if (res && res.code == 200) {
          this.items = res.data.rows
          this.pagination.total = res.data.total
        }
      },
      checked(item) {
        this.$router.push({ path: '/NewResources', query: { _id: item._id } })
      },
      showEdit() {
        this.$router.push({ path: '/NewResources' })
        // this.$store.dispatch('userGroup/reverseShowDialog', true)
      },
      async handleDelete(item) {
            let result = await Swal.fire({
                title: "删除信息",
                text: `${item.name} 记录被删除后将无法恢复，请确认！`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                buttonsStyling: false,
            });

            if (result.value) {
                const delResult = await delCourse(item);
                if (delResult.code == 200) {
                    Swal.fire({
                        title: "已删除!",
                        text: `您已经删除 ${item.name}`,
                        type: "success",
                        confirmButtonClass: "md-button md-success btn-fill",
                        buttonsStyling: false,
                    });
                    this.getList();
                }
            }
        },
    }
  }
  </script>
  